import { RegistrationStatus } from '@services/registrations';

export const STATUS_MAP: {
  status: RegistrationStatus;
  label: string;
  badge: 'accent' | 'warning' | 'info' | 'success' | 'error';
}[] = [
  {
    status: RegistrationStatus.PENDING,
    label: 'Sin asignación',
    badge: 'accent',
  },
  {
    status: RegistrationStatus.SCHEDULED,
    label: 'Agendado',
    badge: 'warning',
  },
  {
    status: RegistrationStatus.INTERVIEWED,
    label: 'Entrevistado',
    badge: 'info',
  },
  {
    status: RegistrationStatus.CONFIRMED,
    label: 'Confirmado',
    badge: 'success',
  },
  {
    status: RegistrationStatus.REJECTED,
    label: 'Rechazado',
    badge: 'error',
  },
];